$(function() {
  if ($('body.stylists-transfers.confirm').length < 1) return

  // submit
  $('.js-complete-transfer-btn').on('click', function() {
    $('.js-complete-form').submit()
    $('.js-spinner-modal').modal('show')
  })
})
